import { alertSuccess } from 'src/store/alert/actions';
import { apiUrl, history } from './../../index';
import { alertError } from './../alert/actions';
import { action } from 'typesafe-actions';
import { SectionActionTypes, Section } from './types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { validateFile, uploadImage } from 'src/utils/imageHelper';
import { ImageActionTypes } from '../image/types';

export const getSections = () => {
  const fetchRequest = () => action(SectionActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Section[]) => action(SectionActionTypes.FETCH_SUCCESS, data);
  const fetchError = (error: Error) => action(SectionActionTypes.FETCH_ERROR, error);

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/section')
      .then(res => {
        dispatch(fetchSuccess(res.data));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const getSection = (sectionTitle: string) => {
  const fetchRequest = () => action(SectionActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Section) => action(SectionActionTypes.FETCH_SUCCESS, data);
  const fetchError = (error: Error) => action(SectionActionTypes.FETCH_ERROR, error);

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + `/section/${sectionTitle}`)
      .then((res: AxiosResponse) => {
        dispatch(fetchSuccess(res.data));
      })
      .catch((err: AxiosError) => {
        if (err.response && err.response.status === 404) {
          history.push('/');
        }
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const deleteSection = (sectionTitle: string) => {
  const fetchRequest = () => action(SectionActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Section) => action(SectionActionTypes.REMOVE_SECTION, { data });
  const fetchError = (error: Error) => action(SectionActionTypes.FETCH_ERROR, error);

  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .delete(apiUrl + `/section/${sectionTitle}`)
      .then((res: AxiosResponse) => {
        dispatch(fetchSuccess(res.data));
      })
      .catch((err: AxiosError) => {
        if (err.response && err.response.status === 404) {
          history.push('/');
        }
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const createSection = (section: Section, successCB: () => any, file?: File) => {
  const fetchRequest = () => action(SectionActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Section) => action(SectionActionTypes.CREATE_SECTION, { data });
  const fetchError = (error: Error) => action(SectionActionTypes.FETCH_ERROR, error);

  return (dispatch: any) => {
    if (file && !validateFile(dispatch, file)) {
      return;
    }
    dispatch(fetchRequest());

    axios
      .post(`${apiUrl}/section/create`, { section })
      .then((res: AxiosResponse) => {
        if (file) {
          dispatch(action(ImageActionTypes.UPLOAD_IMAGE));
          const data = new FormData();
          data.set('sectionId', '' + res.data.section.id);
          uploadImage('section', file, data)
            .then((imageRes: AxiosResponse) => {
              dispatch(action(ImageActionTypes.UPLOAD_SUCCESS));
              const sec = res.data.section;
              sec.image = imageRes.data.image;
              dispatch(fetchSuccess(sec));
              dispatch(alertSuccess('Themenbereich erfolgreich erstellt!'));
              successCB();
            })
            .catch(err => {
              dispatch(action(ImageActionTypes.UPLOAD_ERROR));
              dispatch(fetchError(err));
              dispatch(alertError(new Error('Bild hinzufügen fehlgeschlagen')));
            });
        } else {
          dispatch(fetchSuccess(res.data.section));
          dispatch(alertSuccess('Themenbereich erfolgreich erstellt!'));
          successCB();
        }
      })
      .catch((err: AxiosError) => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const updateSection = (
  oldSectionTitle: string,
  section: Section,
  succesCB: () => any,
  file?: File
) => {
  const fetchRequest = () => action(SectionActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: Section) =>
    action(SectionActionTypes.UPDATE_SECTION, { data, oldSectionTitle });
  const fetchError = (error: Error) => action(SectionActionTypes.FETCH_ERROR, error);

  return (dispatch: any) => {
    if (file && !validateFile(dispatch, file)) {
      return;
    }
    dispatch(fetchRequest());

    axios
      .put(`${apiUrl}/section`, { section })
      .then((res: AxiosResponse) => {
        if (file) {
          dispatch(action(ImageActionTypes.UPLOAD_IMAGE));
          const data = new FormData();
          data.set('sectionId', '' + section.id);
          uploadImage('section', file, data)
            .then((imageRes: AxiosResponse) => {
              dispatch(action(ImageActionTypes.UPLOAD_SUCCESS));
              const sec = res.data.section;
              sec.image = imageRes.data.image;
              dispatch(fetchSuccess(sec));
              dispatch(alertSuccess('Themenbereich erfolgreich editiert!'));
              succesCB();
            })
            .catch(err => {
              dispatch(action(ImageActionTypes.UPLOAD_ERROR));
              dispatch(fetchError(err));
              dispatch(alertError(new Error('Bild hinzufügen fehlgeschlagen')));
            });
        } else {
          dispatch(fetchSuccess(res.data.section));
          dispatch(alertSuccess('Themenbereich erfolgreich editiert!'));
          succesCB();
        }
      })
      .catch((err: AxiosError) => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/sections/actions.ts